import { CompanyActivity } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const BusinessActivitySelectItems = Object.keys(CompanyActivity).map((value) => ({
  value: value.toLowerCase(),
  display: <Text tId={value.toLowerCase()} />,
}));
